import { useCallback, useEffect, useState } from 'react';
import { gameAPI } from '../../lib/gameAPI';
import { CharacterFullView } from '../../types/game';

export function useActiveCharacter(userId?: string) {
  const [activeCharacter, setActiveCharacter] = useState<CharacterFullView | null>(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const fetchActiveCharacter = useCallback(async () => {
    if (!userId) {
      setActiveCharacter(null);
      return;
    }

    try {
      setIsLoading(true);
      setError(null);

      const character = await gameAPI.getActiveCharacter();
      setActiveCharacter(character);
    } catch (err) {
      const message = err instanceof Error ? err.message : 'Failed to load active character';
      setError(message);
      setActiveCharacter(null);
    } finally {
      setIsLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    fetchActiveCharacter();
  }, [fetchActiveCharacter]);

  return {
    activeCharacter,
    isLoading,
    error,
    refresh: fetchActiveCharacter,
  };
}
